module.exports = __webpack_public_path__ + "img/chenxiang.12a4333d.png";